export const locale = {
  lang: 'en',
  data: {
    publicMemberSearch: {
      speciality: 'Speciality',
      municipality: 'Municipality',
      bySpeciality: 'By speciality',
      byMunicipality: 'By city',
      searchForDentist: 'Search for a dentist',
      byPermitNumber: 'By name or permit number',
      searchResults: 'Search results',
      newSearch: 'New search',
      search: 'Search',
      backToResults: 'Back to results',
      criterias: 'Search criteria : ',
      byAdministrativeRegion: 'By administrative region',
      administrativeRegion: 'Administrative region',
      noResult: 'No result with those search criterias',
      isAnesthesiaPrivateClinic: 'Dental care under general anesthesia in a private clinic',
      isAnesthesiaHospital: 'Dental care under general anesthesia in a hospital setting',
      isParticularMedicalCondition: "Providing care to patients with specific medical conditions",
      isHomeVisit: "Patient home care",
      isSleepApnea: "Sleep apnea care",
      isReducedMobility: 'Clinic accessible to people with reduced mobility',
      memberSpecification: 'Special professional activities',
      sLiftPerson: "Have a patient lift available",
    },
    memberPublicInfos: {
      memberInfos: 'Member Informations',
      notAuthorizedMember: "(Not authorized to practice dentistry in Quebec)",
      name: 'Name',
      permitNumber: 'Permit Number',
      permitType: 'Permit Type',
      disciplinaryBoard: {
        label: 'Disciplinary File(s)',
        recordNumber: 'Record Number',
        date: 'Date',
        publicDecisionType: 'Decision',
        documents: 'Document(s)',
        atLeastOneFile: 'At least one disciplinary file concerning this member (details below)',
        none: 'No disciplinary file concerning this member'
      },
      inDateOf: 'As of date : ',

      effectiveExerciseStatus: {
        label: 'Exercice status',
        Active: 'Active',
        Inactive: 'Inactive',
        Terminated: 'Terminated',
        NotAvailable: 'Not Available',
        limitedPractice: "(this member's right to practice is limited)"
      },
      effectiveInscriptionStatus: {
        label: 'Inscription Status',
        Registered: 'Registered',
        NotRegistered: 'Not Registered',
        PermanentNotRegistered: 'Not registered',
        NotAvailable: 'Not Available',
        NotAffected: 'Non Affected',
      },
      professionalDomicile: {
        clinicName: 'Clinic',
        address: 'Address',
        city: 'City',
        phone: 'Phone',
        fax: 'Fax',
        wheelchairAccess: 'Wheelchair access',
        typeOfPractice: 'Type of practice',
        principal: 'Principal'
      },
      specialties: 'Specialties',
      specialitiesDate: 'Date of issue of the specialist certificate(s)',
      limitation: {
        label: 'Limitation Notice',
        startDate: 'Start',
        endDate: 'End',
      },
      assurance: {
        label: 'Insurance',
        hasAssurance: 'Professional liability insurance',
        hasNoAssurance: 'No insurance'
      },
      workAddress: {
        label: 'Work Addresses'
      },
      memberHistory: {
        label: 'Member History',
        swearingDate: "Swearing Date",
        firstInscriptionDate: "First Date of Registration",
        dateDmd: 'Permit Issue Date',
        specialty: {
          obtainedDate: 'Date Obtained',
          description: 'Speciality'
        }
      },
      print: 'Print',
      accessible: 'This clinic is accessible to people with reduced mobility',
      memberSpecification: 'Special professional activities',
      isAnesthesiaPrivateClinic: 'Dental care under general anesthesia in a private clinic',
      isAnesthesiaHospital: 'Dental care under general anesthesia in a hospital setting',
      isParticularMedicalCondition: "Providing care to patients with specific medical conditions",
      isHomeVisit: "Patient home care",
      isSleepApnea: "Sleep apnea care",
      isReducedMobility: 'Clinic accessible to people with reduced mobility',
      isLiftPerson: "Have a patient lift available",
      inactiveSince: "since "
    },
  }
}